import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { soldGoodsRoutes } from '../sold-goods-routes';
import { getFoodReferrerLabel } from '../utils';
import { useSoldFoodAndDrinkItem } from './sold-food-and-drink-item-context';
import { useSoldFoodAndDrinkItemsTabs } from './tabs';

export default function SoldFoodAndDrinkItemLayout() {
  const { item, status, referrer } = useSoldFoodAndDrinkItem();
  const tabs = useSoldFoodAndDrinkItemsTabs();
  const navigate = useNavigate();

  return (
    <Page
      name={item?.soldGood.name}
      page="layout"
      status={status}
      title={`${item?.soldGood.name} - Sold Food and Drink`}
      flexFullHeight
    >
      <PageHeader
        name={item?.soldGood.name}
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Sold goods',
            url: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK),
          },
          {
            label: 'Food and drink',
            url: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK),
          },
          {
            label: item?.soldGood.name || 'Item',
            url: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK_ITEM, {
              item_uuid: item?.soldGood.uuid || '',
            }),
          },
        ]}
        toolbar={
          referrer ? (
            <Button
              variant="ghost"
              onClick={() => navigate(referrer)}
              icon={<Icons.chevronLeft className="size-4" />}
            >
              {getFoodReferrerLabel(referrer)}
            </Button>
          ) : undefined
        }
      />
      <Outlet />
    </Page>
  );
}
